export default Object.freeze({
  datacenterRegion: {
    title: 'Datacenter Region',
    message: 'Choose a data center region which is closer to you.',
  },
  fileListing: {
    title: 'File Listing',
    message: '---',
  },
  bucketVersioning: {
    title: 'Bucket Versioning',
    message: '---',
  },
  objectLock: {
    title: 'Object Lock',
    message: '---',
  },
  subdomain: {
    title: 'Subdomain',
    message: '<p>Choose a unique subdomain for your Bucket. The name of the Bucket makes up part of its endpoint URL and cannot be changed once it is created. Subdomain name must:</p> <p>Be unique among all users in all regions. If the name you choose is already in use, a message will appear which says Bucket name already exists. Be between 3 and 63 characters long. Must contain only lowercase letters, numbers, and dashes. Begin with a letter.</p>',
  },
  tags: {
    title: 'Tags',
    message: '----',
  },
  cors: {
    title: 'Cors',
    message: '-----',
  },
  cdn: {
    title: 'CDN',
    message: 'A CDN (Content Delivery Network) is a distributed group of servers in a data center called Point of Presence, that provide fast delivery of web content.',
  },
})
